import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { PromoContext } from "@context/PromoContext";
import TicketIcon from "@components/Icons/TicketIcon";
import { getTime } from "@utils/dateUtils";
import { isSessionValidPromo } from "@utils/promoUtils";
import { getSessionButtonText, getVoucherUpgradeDetails } from "@utils/ticketUtils";
import "./style.scss";

const V3SessionButton = ({ session }) => {
    const location = useLocation();
    const { promoOptions } = useContext(PromoContext);

    let showPromoIcon = false;
    let price = session?.ticket_price_cents;
    let savings = session?.saving;
    const rrp = session?.rrp_pricing_cents;

    if (!session) return null;

    if (promoOptions?.length === 1) {
        const promo = promoOptions[0];
        const reuseLimitReached = promo?.promo_reuse_count >= promo?.reuse_limit;

        if (!reuseLimitReached) {
            const matchedPromo = isSessionValidPromo(promo, session);
            price = matchedPromo?.adult_price_cents ?? session?.ticket_price_cents;
            showPromoIcon = !!matchedPromo;
            savings = rrp - price;
        }
    }

    const buttonClass = getSessionButtonText(session).replace(/\s+/g, "");

    const upgradeDetails = getVoucherUpgradeDetails(session);
    const upgradeFeeCents = (upgradeDetails?.fee || 0) * 100;
    const netSavingsCents = savings - upgradeFeeCents;

    return (
        <Link
            key={session.id}
            className={`v3-sessions-button__item v3-sessions-button__item--${buttonClass}`}
            to={`/ticket/purchase/${session.id}`}
            state={{ from: location.pathname + location.search }}
        >
            <div className="v3-sessions-button__detail">
                <div className="v3-sessions-button__group-item time">
                    {getTime(session.session_date)}
                </div>

                <div className="v3-sessions-button__group-item type">
                    {getSessionButtonText(session)}
                </div>

                <div className="v3-sessions-button__group-item price">
                    ${(price / 100).toFixed(2)}
                </div>
            </div>
            <div className="v3-sessions-button__pricing">
                <span className="v3-sessions-button__group-item rrp">
                    RRP: ${(session.rrp_pricing_cents / 100).toFixed(2)}
                </span>

                {showPromoIcon ? (
                    <span className="v3-sessions-button__group-item promo_icon">
                        <TicketIcon className="button__icon" />
                    </span>
                ): null}
                {netSavingsCents > 0 && (
                    <span className="v3-sessions-button__group-item save">
                        SAVE: ${(netSavingsCents / 100).toFixed(2)}
                    </span>
                )}

            </div>
        </Link>
    );
};

export default V3SessionButton;
